// Centralized canonical fixed palettes shared across the app.
// This file intentionally excludes palettes that should preserve ordered
// user palettes (e.g., megaDrive16, gameGear, masterSystem) and includes
// Game Boy variants as fixed palettes.
export const FIXED_PALETTES: Record<string, number[][]> = {
  cga0: [ [0,0,0], [255,85,255], [85,255,255], [255,255,255] ],
  cga1: [ [0,0,0], [85,255,85], [255,85,85], [255,255,85] ],
  cga2: [ [0,0,0], [255,85,85], [85,255,255], [255,255,255] ],
  gameboyRealistic: [ [56,72,40], [96,112,40], [160,168,48], [208,224,64] ],
  gameboy: [ [15,56,15], [48,98,48], [139,172,15], [155,188,15] ],
  gameboyBg: [ [7,24,33], [48,104,80], [134,192,108], [224,248,207] ],
  amstradCpc: [
    [0,0,0],[128,128,128],[255,255,255],[128,0,0],[255,0,0],[255,128,128],[255,127,0],[255,255,128],[255,255,0],[128,128,0],[0,128,0],[0,255,0],[128,255,0],[128,255,128],[0,255,128],[0,128,128],[0,255,255],[128,255,255],[0,128,255],[0,0,255],[0,0,128],[128,0,255],[128,128,255],[255,128,255],[255,0,255],[255,0,128],[128,0,128]
  ],
  nes: [
    [88,88,88],[0,35,124],[13,16,153],[48,0,146],[79,0,108],[96,0,53],[92,5,0],[70,24,0],[39,45,0],[9,62,0],[0,69,0],[0,65,6],[0,53,69],[0,0,0],[0,0,0],[0,0,0],[161,161,161],[11,83,215],[51,55,254],[102,33,247],[149,21,190],[172,22,110],[166,39,33],[134,67,0],[89,98,0],[45,122,0],[12,133,0],[58,217,116],[57,195,223],[66,66,66],[0,0,0],[0,0,0],[255,255,255],[81,165,254],[128,132,254],[188,106,254],[249,91,254],[254,94,196],[254,115,105],[228,147,33],[174,182,0],[121,211,0],[81,223,33],[58,215,116],[57,195,223],[66,66,66],[0,0,0],[0,0,0],[255,255,255],[181,217,254],[202,202,254],[227,190,254],[249,183,254],[254,186,231],[254,195,188],[244,209,153],[222,224,134],[198,236,135],[178,242,157],[167,240,195],[168,231,240],[172,172,172],[0,0,0],[0,0,0]
  ],
  commodore64: [
    [0,0,0],[98,98,98],[137,137,137],[173,173,173],[255,255,255],[159,78,68],[203,126,117],[109,84,18],[161,104,60],[201,212,135],[154,226,155],[92,171,94],[106,191,198],[136,126,203],[80,69,155],[160,87,163]
  ],
  zxSpectrum: [
    [0,0,0],[0,0,216],[0,0,255],[216,0,0],[255,0,0],[216,0,216],[255,0,255],[0,216,0],[0,255,0],[0,216,216],[0,255,255],[216,216,0],[255,255,0],[216,216,216],[255,255,255]
  ]
};

export const FIXED_KEYS = new Set<string>(Object.keys(FIXED_PALETTES));

export default FIXED_PALETTES;
